import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Virginia Cellar · Your Wine Destination</p>
        <h1>Discover the Best Wines from Virginia</h1>
        <p className="lede">
          At Virginia Cellar, we curate an exceptional selection of local wines, showcasing the rich flavors and unique terroirs of Virginia. Explore our collection and find your perfect bottle today.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Shop Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Explore Our Collection</h2>
          <p>
            From bold reds to crisp whites, our diverse selection features the finest wines crafted by Virginia's top vineyards.
          </p>
        </article>
        <article>
          <h2>Join Our Wine Club</h2>
          <p>
            Sign up for exclusive access to limited releases, special events, and curated selections delivered right to your door.
          </p>
        </article>
        <article>
          <h2>Visit Us</h2>
          <p>
            Experience the beauty of Virginia wine country. Join us for tastings, tours, and events that celebrate our local winemakers.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;